<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>报销审批人设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="between">
      <div class="left_con">
        <el-input size="mini"
                  style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                  placeholder="输入关键字进行过滤"
                  v-model="filterText">
        </el-input>
        <el-tree
          :data="orgList"
          :props="treeProps"
          @node-click="handleNodeClick"
          :highlight-current="true"
          node-key="id"
          :filter-node-method="filterNode"
          ref="tree"
        >
        </el-tree>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
        <el-button size="mini"  plain @click="showCreateRuleDialog"
                   >创建审批规则</el-button>
        <el-button size="mini"  plain @click="setAreaSpRule"
                   >设置区域审批</el-button>
        <el-button size="mini"  plain @click="setShopSpRule"
                   >设置门店审批</el-button>
        <div style="width: 100%;height: 30px;">
          <el-table height="550px" :data="spRuleList" fit border stripe="stripe"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}" @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              align="center"
              prop="firstSpName"
              label="一级审批人" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="secSpName"
              label="二级审批人" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="thrSpName"
              label="三级审批人" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="zdSpMoney"
              label="自动审批条件" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="csName"
              label="抄送人" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="zxName"
              label="执行人" >
            </el-table-column>
          </el-table>
        </div>

      </div>

      <!-- 添加分类 -->
      <el-dialog
        title="创建审批规则"
        :visible.sync="createRuleDialogVisible"
        width="50%"
        style="position: absolute"
        @close="closeCreateRuleDialog"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <div style="display: flex;justify-content: space-evenly;justify-items: center">
          <span style="width: 50%">一级审批人：{{oneSpUser.userName}}</span>
          <div style="width: 50%">
            <el-button size="mini" @click="showUserDialog('one')">选择</el-button>
          </div>
        </div>
        <div style="display: flex;justify-content: space-evenly;justify-items: center;margin-top: 10px">
          <span style="width: 50%">二级审批人：{{twoSpUser.userName}}</span>
          <div style="width: 50%">
            <el-button size="mini" @click="showUserDialog('two')">选择</el-button>
          </div>
        </div>
        <div style="display: flex;justify-content: space-evenly;justify-items: center;margin-top: 10px">
          <span style="width: 50%">三级审批人：{{thrSpUser.userName}}</span>
          <div style="width: 50%">
            <el-button size="mini" @click="showUserDialog('thr')">选择</el-button>
          </div>
        </div>
        <div style="display: flex;justify-content: space-evenly;justify-items: center;margin-top: 10px">
          <span style="width: 50%">抄送人：{{csUserName}}</span>
          <div style="width: 50%">
            <el-button size="mini" @click="showUserDialog('cs')">选择</el-button>
          </div>
        </div>
        <div style="display: flex;justify-content: space-evenly;justify-items: center;margin-top: 10px">
          <span style="width: 50%">执行人：{{zxUser.userName}}</span>
          <div style="width: 50%">
            <el-button size="mini" @click="showUserDialog('zx')">选择</el-button>
          </div>
        </div>
        <div style="display: flex;justify-content: space-evenly;justify-items: center;margin-top: 10px">
          <span style="width: 50%">设置自动审批条件：{{zxUser.userName}}</span>
          <div style="width: 50%">
            <el-input size="mini" v-model="spRule.zdSpMoney" onkeyup="value=value.replace(/[^\d]/g,'')"
              style="width: 120px;"></el-input>元
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeCreateRuleDialog">取 消</el-button>
            <el-button size="mini" @click="createSpRule">确 定</el-button>
          </span>
      </el-dialog>

      <!-- 添加分类 -->
      <el-dialog
        title="选择人员"
        :visible.sync="userDialogVisible"
        width="40%"
        style="position: absolute"
        @close="closeUserDialog"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <div style="width: 100%;">
          <el-checkbox-group style="width: 90%;" size="mini" v-model="selectUserId" @change="checkUsers">
            <el-checkbox style="margin-top: 15px"
                         v-for="(item,index) in userList"
                         :key="index" :label="item.id">
              {{item.userName}}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeUserDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      createRuleDialogVisible:false,
      userDialogVisible:false,
      authorities:'',
      currentOrgId:'',
      userId:'',
      orgList: [],
      ruleList:[],
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      filterText: '',
      userList:[],
      selectUserId:[],
      csList:[],
      spType:'',
      oneSpUser:{},
      twoSpUser:{},
      thrSpUser:{},
      zxUser:{},
      csUserName:{},
      spRule:{
        firstSpId:'',
        firstSpName:'',
        secSpId:'',
        secSpName:'',
        thrSpId:'',
        thrSpName:'',
        zxId:'',
        zxName:'',
        csIds:[],
        creator:0,
        orgId:0,
        zdSpMoney:0
      },
      csIds:[],
      selectedSpId:'',
      spRuleList:[]
    }
  },
  methods:{
    async handleNodeClick(data) {
      this.selectOrgId = data.id;
      await this.loadUserByOrgId(data);
      await this.loadSpRule();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.currentOrgId}`);
      this.orgList = [res.data];
    },
    async loadUserByOrgId(data){
      const {data:res} = await this.$http.get(`/load/org/area/jt/${data.id}`);
      this.userList = res.data;
    },
    async loadSpRule(){
      const {data:res} = await this.$http.get(`/load/sp/rule/${this.selectOrgId}`);
      this.spRuleList = res.data;
    },
    closeCreateRuleDialog(){
      this.createRuleDialogVisible = false;
    },
    showCreateRuleDialog(){
      this.csUserName = '';
      this.createRuleDialogVisible = true;
    },
    async createSpRule(){
      this.spRule.firstSpId = this.oneSpUser.id;
      this.spRule.firstSpName = this.oneSpUser.userName;
      this.spRule.secSpId = this.twoSpUser.id;
      this.spRule.secSpName = this.twoSpUser.userName;
      this.spRule.thrSpId = this.thrSpUser.id;
      this.spRule.thrSpName = this.thrSpUser.userName;
      this.spRule.csIds = this.csIds;
      this.spRule.zxId = this.zxUser.id;
      this.spRule.zxName = this.zxUser.userName;
      this.spRule.creator = this.userId;
      this.spRule.orgId = this.selectOrgId;
      const {data:res} = await this.$http.post('/create/sp/rule', this.spRule);
      if(res.code === 200){
        this.$message.success("操作成功");
      }
      this.closeCreateRuleDialog();
      await this.loadSpRule();
    },
    showUserDialog(type){
      this.spType = type;
      this.selectUserId = [];
      this.userDialogVisible = true;
    },
    closeUserDialog(){
      this.userDialogVisible = false;
    },
    checkUsers(selectedId){
      if(this.spType === 'one'){
        if(this.selectUserId.length > 1){
          return this.$message.warning("只能选择一位一级审批人");
        }
        this.userList.map((item) => {
          if(item.id === selectedId[0]){
            this.oneSpUser = item;
          }
        })
      }
      if(this.spType === 'two'){
        if(this.selectUserId.length > 1){
          return this.$message.warning("只能选择一位二级审批人");
        }
        this.userList.map((item) => {
          if(item.id === selectedId[0]){
            this.twoSpUser = item;
          }
        })
      }
      if(this.spType === 'thr'){
        if(this.selectUserId.length > 1){
          return this.$message.warning("只能选择一位三级审批人");
        }
        this.userList.map((item) => {
          if(item.id === selectedId[0]){
            this.thrSpUser = item;
          }
        })
      }
      if(this.spType === 'zx'){
        if(this.selectUserId.length > 1){
          return this.$message.warning("只能选择一位执行人");
        }
        this.userList.map((item) => {
          if(item.id === selectedId[0]){
            this.zxUser = item;
          }
        })
      }
      if(this.spType === 'cs'){
        this.csUserName = '';
        this.userList.map((item) => {
          if(selectedId.includes(item.id)){
            this.csList.push(item);
            this.csUserName += item.userName + ' '
          }
        })
        this.csIds = selectedId;
      }
    },
    handleSelectionChange(val) {
      if(val.length > 1){
        return this.$message.warning("请选择一个规则进行配置");
      }
      this.selectedSpId = val[0];
    },
    async setAreaSpRule(){
      const {data:res} = await this.$http.post('/set/org/sp/rule', {
        areaId: this.selectOrgId,
        spRuleId: this.selectedSpId.id,
        orgLevel: 2
      });
      if(res.code === 200){
        this.$message.success("操作成功");
      }
    },
    async setShopSpRule(){
      const {data:res} = await this.$http.post('/set/org/sp/rule', {
        areaId: this.selectOrgId,
        spRuleId: this.selectedSpId.id,
        orgLevel: 3
      });
      if(res.code === 200){
        this.$message.success("操作成功");
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
}
.table_container{
  flex: 4;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 50px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BxSpSet.vue